import { PaymentMethod } from '@entities/payment'
import { Amount } from '@root/api/ump-ewallet'

export const getClientFeeAmount = (
  amount: Amount | null,
  isPubg: boolean,
  isNonTopUpService: boolean,
  isTopUpWithPercentFeeService: boolean,
  paymentMethod: PaymentMethod
) => {
  if (!amount || !amount.base) return '0'

  if (isPubg || isTopUpWithPercentFeeService) {
    if (paymentMethod === PaymentMethod.CARD) {
      return amount.fee
    }

    return 0
  }

  if (isNonTopUpService) {
    if (paymentMethod === PaymentMethod.CARD) {
      return amount.fee
    }

    return Number(amount.fee) / 2
  }

  return amount.fee || ''
}
